export default "/assets/website/images/search.svg?688d51c411d4aedc17a1577a8cc21b81";